import { useContext } from 'react';
import { Context, defaultLocale } from './ConstellationProvider.context.js';

function useLocalization(locales) {
    const { locale } = useContext(Context);
    // Falls back to the default language if no translations are available for the supplied locale
    const strings = 
    // deepcode ignore GlobalReplacementRegex: We only need to match the first instance, as there should only be a single instance
    locales[locale.replace(/-/, "")] || locales[defaultLocale.replace(/-/, "")];
    return {
        strings,
        locale,
    };
}
function useConstellationProviderRef() {
    const { constellationProviderRef } = useContext(Context);
    return {
        constellationProviderRef,
    };
}

export { useConstellationProviderRef, useLocalization };
//# sourceMappingURL=ConstellationProvider.hooks.js.map
